import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
} from "react-router-dom";
import { ConfigProvider, App as AntApp } from "antd";
import { themeConfig } from "./theme";
import "antd/dist/reset.css";

import Homepage from "./components/Homepage";
import Login from "./components/Login";
import Admin from "./components/Admin";
import ExistingUser from "./components/UserDetails";
import ApiCollection from "./components/ApiCollection";
import AddUser from "./components/AddUser";
import RCDelete from "./components/RCDelete";
import ApiDocumentation from "./components/ApiDocumentation";
import RESTQueryBuilder from "./components/RESTQueryBuilder";
import S3FileManager from "./components/S3FileManager";
import PrivateRoute from "./components/PrivateRoute";
import RoleBasedRoute from "./components/RoleBasedRoute";

const App = () => {
  return (
    <ConfigProvider theme={themeConfig}>
      <AntApp>
        <Router>
          <div className="min-h-screen flex flex-col">
            <Routes>
              <Route path="/" element={<Homepage />} />
              <Route path="/login" element={<Login />} />
              <Route
                path="/dashboard"
                element={
                  <PrivateRoute>
                    <Admin />
                  </PrivateRoute>
                }
              />
              <Route
                path="/admin"
                element={
                  <PrivateRoute>
                    <Admin />
                  </PrivateRoute>
                }
              />
              <Route
                path="/users"
                element={
                  <RoleBasedRoute allowedRoles={["admin"]}>
                    <ExistingUser />
                  </RoleBasedRoute>
                }
              />
              <Route
                path="/api-collection"
                element={
                  <RoleBasedRoute allowedRoles={["admin"]}>
                    <ApiCollection />
                  </RoleBasedRoute>
                }
              />
              <Route
                path="/add-user"
                element={
                  <RoleBasedRoute allowedRoles={["admin"]}>
                    <AddUser />
                  </RoleBasedRoute>
                }
              />
              <Route
                path="/rc/delete"
                element={
                  <RoleBasedRoute allowedRoles={["admin"]}>
                    <RCDelete />
                  </RoleBasedRoute>
                }
              />
              <Route
                path="/documentation"
                element={
                  <PrivateRoute>
                    <ApiDocumentation />
                  </PrivateRoute>
                }
              />
              <Route
                path="/rest-query-builder"
                element={
                  <PrivateRoute>
                    <RESTQueryBuilder />
                  </PrivateRoute>
                }
              />
              <Route
                path="/s3-files"
                element={
                  <PrivateRoute>
                    <S3FileManager />
                  </PrivateRoute>
                }
              />
            </Routes>
          </div>
        </Router>
      </AntApp>
    </ConfigProvider>
  );
};

export default App;
